// Module
var code = "<div class=\"toggle-all\"> <a ng-click=\"handleToggle()\" class=\"btn-default-general btn-default-secondary\"> Toggle All </a> </div> ";
// Exports
module.exports = code;